
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 8.25c.966 0 1.75.784 1.75 1.75v20A1.75 1.75 0 0130 31.75H10A1.75 1.75 0 018.25 30V10c0-.966.784-1.75 1.75-1.75h20zM12.63 23.57l-2.88 2.75V30c0 .138.112.25.25.25h20a.25.25 0 00.25-.25v-4.573l-1.542 1.683-3.208-3.5-3.208 3.5-3.209-3.5-3.208 3.5-3.244-3.54zm0-8.5l-2.88 2.75v6.427l2.952-2.818 3.173 3.461 3.208-3.5 3.209 3.5 3.208-3.5 3.208 3.5 1.542-1.682v-6.281l-1.542 1.683-3.208-3.5-3.208 3.5-3.209-3.5-3.208 3.5-3.244-3.54zM30 9.75H10a.25.25 0 00-.25.25v5.747l2.952-2.818 3.173 3.461 3.208-3.5 3.209 3.5 3.208-3.5 3.208 3.5 1.542-1.682V10a.25.25 0 00-.25-.25z","fill":"#409EFF"}})])
          )
        }
      }
    